<template>
  <div class="inter-wrapper">
    <HeaderInter />
    <!-- <Promotionsbanner /> -->
    <!-- 確認訂單 -->
    <div v-if="ready" class="inter-content">
      <div class="orderinit-area container-fluid">
        <vsa-list>
          <vsa-item>
            <vsa-heading> {{ $langt('訂單明細') }} </vsa-heading>
            <vsa-content>
              <div class="order-area">
                <div class="box-group">
                  <div class="box-items">
                    <div class="box-th">
                      {{ $langt('商品') }}
                    </div>
                    <div class="box-td">
                      {{ productDetail.name }}
                    </div>
                  </div>
                  <div class="box-items">
                    <div class="box-th">
                      {{ $langt('方案') }}
                    </div>
                    <div class="box-td">
                      {{ orderItem.plan().plan_name
                      }}{{ orderItem.priceName() | pricename }}
                    </div>
                  </div>
                  <div class="box-items">
                    <div class="box-th">
                      {{ $langt('價格') }}
                    </div>
                    <div class="box-td">
                      {{ orderItem.pricePointLabel() }}
                    </div>
                  </div>
                  <div class="box-items">
                    <div class="box-th">
                      {{ $langt('數量') }}
                    </div>
                    <div class="box-td">
                      {{ orderItem.qty() }}
                    </div>
                  </div>
                </div>
              </div>
            </vsa-content>
          </vsa-item>
        </vsa-list>

        <div class="order-area">
          <div class="sub-title">
            <span>{{ $langt('聯絡人資訊') }}</span>
          </div>

          <div class="form-area mb-3">
            <div
              v-if="
                $store.getters.memberInfo &&
                  $store.getters.memberInfo.name &&
                  $store.getters.memberInfo.name !== ''
              "
              class="radiocheck check"
            >
              <input
                id="checkmember"
                v-model="isUseMember"
                type="checkbox"
                class="checkbox"
                name="checkmember"
                @change="toggleSync(isUseMember)"
              >
              <label for="checkmember">{{ $langt('同票夾聯絡人資料') }}</label>
            </div>
            <div class="order-info-div">
              <input
                ref="bill_name"
                v-model="infoForm.bill_name"
                v-validate="'required|min:2'"
                name="bill_name"
                :data-vv-as="$langt('付款人姓名')"
                type="text"
                class="box"
                :placeholder="$langt('付款人姓名')"
                :disabled="
                  infoForm.is_use_member === 't' && infoForm.bill_name !== ''
                "
              >
              <div v-if="errors.has('bill_name')" class="help-block">
                {{ errors.first('bill_name') }}
              </div>
            </div>
            <div class="order-info-div order-info__phone">
              <select
                v-if="!isUseMember"
                v-model="infoForm.phone_type"
                class="phone-select"
              >
                <option v-for="option in phoneOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
              <div v-if="!isUseMember">
                <input v-if="infoForm.phone_type === 1" :value="countryCodeDefault" type="text" class="country-code" :placeholder="$langt('國碼')" disabled>
                <template v-if="infoForm.phone_type === 2">
                  <input
                    v-model="infoForm.bill_country_code"
                    v-validate="'required'"
                    type="text"
                    class="country-code"
                    name="bill_country_code"
                    :placeholder="$langt('國碼')"
                    :data-vv-as="$langt('國碼')"
                  >
                  <div v-if="errors.has('bill_country_code')" class="help-block">
                    {{ errors.first('bill_country_code') }}
                  </div>
                </template>
              </div>
              <div class="phone-number">
                <input
                  ref="bill_phone"
                  v-model="infoForm.bill_phone"
                  v-validate="'required'"
                  type="tel"
                  class="box"
                  name="bill_phone"
                  :data-vv-as="$langt('付款人手機')"
                  :placeholder="
                    $langt('付款人手機') + ' ' +
                      (type === 'point' && channel === 'happygo'
                        ? ('(' + $langt('HappyGo手機號') + ')')
                        : '')
                  "
                  :disabled="
                    infoForm.is_use_member === 't' && infoForm.bill_name !== ''
                  "
                >
                <div v-if="errors.has('bill_phone')" class="help-block">
                  {{ errors.first('bill_phone') }}
                </div>
              </div>
            </div>
            <div class="order-info-div -">
              <input
                ref="bill_email"
                v-model="infoForm.bill_email"
                v-validate="'required|email'"
                type="email"
                class="box"
                name="bill_email"
                :data-vv-as="$langt('付款人Email')"
                :placeholder="$langt('付款人Email')"
                :disabled="
                  infoForm.is_use_member === 't' && infoForm.bill_name !== ''
                "
              >
              <div v-if="errors.has('bill_email')" class="help-block">
                {{ errors.first('bill_email') }}
              </div>
            </div>
            <div
              v-if="type === 'point' && channel === 'happygo'"
              class="order-info-div"
            >
              <input
                v-model="infoForm.id_no"
                v-validate="'required|min:4|max:4|integer'"
                type="text"
                class="box"
                name="id_no"
                :data-vv-as="$langt('身分證後4碼')"
                :placeholder="$langt('身分證後4碼') + ' (' + $langt('HappyGo身分證後四碼') + ')'"
              >
              <div v-if="errors.has('id_no')" class="help-block">
                {{ errors.first('id_no') }}
              </div>
            </div>
          </div>
        </div>

        <!-- 收件人資訊 -->
        <div
          v-if="productDetail.style === 2 || productDetail.style === 3"
          class="order-area"
        >
          <div class="sub-title">
            <span>{{ $langt('收件人資訊') }}</span>
          </div>
          <div class="form-area mb-3">
            <div class="order-info-div">
              <input
                v-model="infoForm.ship_name"
                v-validate="'required|min:2'"
                type="text"
                class="box"
                name="ship_name"
                :placeholder="$langt('收件人姓名')"
                :data-vv-as="$langt('收件人姓名')"
              >
              <div v-if="errors.has('ship_name')" class="help-block">
                {{ errors.first('ship_name') }}
              </div>
            </div>
            <div class="order-info-div order-info__phone">
              <select
                v-model="infoForm.ship_phone_type"
                class="phone-select"
                @change="setShipCountryCode(infoForm.ship_phone_type)"
              >
                <option v-for="option in phoneOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
              <div>
                <input
                  v-if="infoForm.ship_phone_type === 1"
                  :value="countryCodeDefault"
                  type="text"
                  class="country-code"
                  :placeholder="$langt('國碼')"
                  disabled
                >
                <template v-if="infoForm.ship_phone_type === 2">
                  <input
                    v-model="infoForm.ship_country_code"
                    v-validate="'required'"
                    type="text"
                    class="country-code"
                    name="ship_country_code"
                    :placeholder="$langt('國碼')"
                    :data-vv-as="$langt('國碼')"
                  >
                  <div v-if="errors.has('ship_country_code')" class="help-block">
                    {{ errors.first('ship_country_code') }}
                  </div>
                </template>
              </div>
              <div class="phone-number">
                <input
                  ref="ship_phone"
                  v-model="infoForm.ship_phone"
                  v-validate="'required'"
                  type="tel"
                  class="box"
                  name="ship_phone"
                  :data-vv-as="$langt('收件人電話')"
                  :placeholder="$langt('收件人電話')"
                >
                <div v-if="errors.has('ship_phone')" class="help-block">
                  {{ errors.first('ship_phone') }}
                </div>
              </div>
            </div>
            <div class="order-info-div order-info__address">
              <select
                v-model="infoForm.ship_city_id"
                class="ship-select"
                @change="getAreaList(infoForm.ship_city_id)"
              >
                <option v-for="option in cityList" :key="option.city_id" :value="option.city_id">
                  {{ option.name }}
                </option>
              </select>
              <select
                v-model="infoForm.ship_area_id"
                class="ship-select"
              >
                <option v-for="option in areaList" :key="option.area_id" :value="option.area_id">
                  {{ option.name }}
                </option>
              </select>
              <div class="ship-addr">
                <input
                  ref="ship_addr"
                  v-model="infoForm.ship_addr"
                  v-validate="'required'"
                  type="text"
                  class="box"
                  name="ship_addr"
                  :data-vv-as="$langt('收件人地址')"
                  :placeholder="$langt('收件人地址')"
                >
                <div v-if="errors.has('ship_addr')" class="help-block">
                  {{ errors.first('ship_addr') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 出行人資料 :訂單-->
        <div
          v-if="
            infoForm.touristprequest && infoForm.touristprequest.people.length
          "
          class="order-area"
        >
          <div class="sub-title">
            <span>{{ $langt('訂單附加資料填寫') }}</span>
          </div>
          <div class="p-0 ">
            <div
              v-for="(person, index) in infoForm.touristprequest.people"
              :key="index"
            >
              <div
                v-if="infoForm.touristprequest.people.length > 1"
                class="passengerlist"
                :class="{ topline: index > 0 }"
              >
                {{ $langt('第') }}{{ index + 1 }}{{ $langt('位旅客') }}
              </div>
              <div
                v-for="(request, i) in person.data"
                :key="i"
                class="mb-1 form-area"
              >
                <div
                  v-if="request.data_type === 'text' || request.data_type === '1'"
                  class="d-flex justify-content-center align-items-center row"
                  align-v="center"
                >
                  <div class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>
                    {{ request.question_name }}
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    />
                  </div>
                  <input
                    :ref="request.question_code + index + i"
                    v-model="request.val"
                    v-validate="`${isrequired(request.is_required)}`"
                    type="text"
                    class="formbox col-12"
                    :placeholder="$langt('請填寫')"
                    :data-vv-as="request.question_name"
                    :name="request.question_code + index + i"
                  >
                  <div
                    v-if="errors.has(request.question_code + index + i)"
                    class="help-block passengewarn"
                  >
                    {{ errors.first(request.question_code + index + i) }}
                  </div>
                </div>
                <div
                  v-else-if="request.data_type === 'number' || request.data_type === '2'"
                  class="d-flex justify-content-center align-items-center row"
                >
                  <div class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>
                    {{ request.question_name }}
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    />
                  </div>
                  <input
                    :ref="request.question_code + index + i"
                    v-model="request.val"
                    v-validate="`${isrequired(request.is_required)}|numeric`"
                    type="text"
                    class="formbox col-12"
                    :placeholder="$langt('請填寫')"
                    :data-vv-as="request.question_name"
                    :name="request.question_code + index + i"
                  >
                  <div
                    v-if="errors.has(request.question_code + index + i)"
                    class="help-block passengewarn"
                  >
                    {{ errors.first(request.question_code + index + i) }}
                  </div>
                </div>
                <div
                  v-else-if="request.data_type === 'boolean' || request.data_type === '3'"
                  class="d-flex justify-content-start align-items-center row"
                >
                  <div class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>
                    {{ request.question_name }}
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    />
                  </div>
                  <div class="col-5">
                    <input
                      :ref="request.question_code + index + i"
                      v-model="request.val"
                      v-validate="`${isrequired(request.is_required)}`"
                      type="radio"
                      :value="true"
                      class="checkbox "
                      :data-vv-as="request.question_name"
                      :name="request.question_code + index + i"
                    >
                    <span> {{ $langt('是') }}</span>
                  </div>
                  <div class="col-5">
                    <input
                      :ref="request.question_code + index + i"
                      v-model="request.val"
                      v-validate="`${isrequired(request.is_required)}`"
                      type="radio"
                      class="checkbox "
                      :value="false"
                      :data-vv-as="request.question_name"
                      :name="request.question_code + index + i"
                    >
                    <span> {{ $langt('否') }}</span>
                  </div>
                  <div
                    v-if="errors.has(request.question_code + index + i)"
                    class="help-block col-12 passengewarn"
                  >
                    {{ errors.first(request.question_code + index + i) }}
                  </div>
                </div>
                <div
                  v-else-if="request.data_type === 'single' || request.data_type === '7'"
                  class="d-flex justify-content-start align-items-center row"
                >
                  <label class=" col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>
                    {{ request.question_name }}
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    />
                  </label>
                  <b-form-select
                    :ref="request.question_code + index + i"
                    v-model="request.val"
                    v-validate="`${isrequired(request.is_required)}`"
                    class="col-12"
                    :data-vv-as="request.question_name"
                    :name="request.question_code + index + i"
                  >
                    <b-form-select-option
                      v-for="option in request.data_options"
                      :key="option.value"
                      :value="option.value"
                      :placeholder="$langt('請選擇')"
                    >
                      {{ option.label }}
                    </b-form-select-option>
                  </b-form-select>
                  <div
                    v-if="errors.has(request.question_code + index + i)"
                    class="help-block col-12 passengewarn"
                  >
                    {{ errors.first(request.question_code + index + i) }}
                  </div>
                </div>
                <div
                  v-else-if="request.data_type === 'multiple' || request.data_type === '8'"
                  class="d-flex justify-content-start align-items-center row"
                >
                  <label class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>{{ request.question_name }}
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    /></label>
                  <b-form-select
                    :ref="request.question_code + index + i"
                    v-model="request.val"
                    v-validate="`${isrequired(request.is_required)}`"
                    class="col-12"
                    multiple
                    :placeholder="$langt('請選擇')"
                    :data-vv-as="request.question_name"
                    :name="request.question_code + index + i"
                  >
                    <b-form-select-option
                      v-for="option in request.data_options"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.label }}
                    </b-form-select-option>
                  </b-form-select>
                  <div
                    v-if="errors.has(request.question_code + index + i)"
                    class="help-block col-12 passengewarn"
                  >
                    {{ errors.first(request.question_code + index + i) }}
                  </div>
                </div>
                <!-- 顯示預訂時間 -->
                <div 
                v-else-if="request.data_type === 'datetime' || request.data_type === '4'"
                class="d-flex justify-content-start align-items-center row">
                  <label class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>{{ request.question_name }}({{$langt('當地時間')}})
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    />
                  </label>
                  <div>
                      {{ orderItem.item.plans[0].prices[0].date }} {{ orderItem.item.plans[0].prices[0].selectedTime }}
                  </div>
                </div>
                <div 
                v-else-if="request.data_type === 'datetime' || request.data_type === '6'"
                class="d-flex justify-content-start align-items-center row">
                  <label class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>{{ request.question_name }}({{$langt('當地時間')}})
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    />
                  </label>
                  <div>
                      {{ orderItem.item.plans[0].prices[0].date }} {{ orderItem.item.plans[0].prices[0].selectedTime }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 出行人資料 :旅客-->
        <div
          v-if="
            infoForm.bookingprequest && infoForm.bookingprequest.people.length
          "
          class="order-area"
        >
          <div class="sub-title">
            <span>{{ $langt('旅客資料填寫') }}</span>
          </div>
          <div class="p-0">
            <div
              v-for="(person, index) in infoForm.bookingprequest.people"
              :key="index"
            >
              <div
                v-if="infoForm.bookingprequest.people.length > 1"
                class="passengerlist"
                :class="{ topline: index > 0 }"
              >
                {{ $langt('第') }}{{ index + 1 }}{{ $langt('位旅客') }}
              </div>
              <div
                v-for="(request, i) in person.data"
                :key="i"
                class="mb-1 form-area"
              >
                <div
                  v-if="request.data_type === 'text' || request.data_type === '1'"
                  class="d-flex justify-content-center align-items-center row"
                  align-v="center"
                >
                  <div class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>
                    {{ request.question_name }}
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    />
                  </div>
                  <input
                    :ref="request.question_code + index + i"
                    v-model="request.val"
                    v-validate="`${isrequired(request.is_required)}`"
                    type="text"
                    class="formbox col-12"
                    :placeholder="$langt('請填寫')"
                    :data-vv-as="request.question_name"
                    :name="request.question_code + index + i"
                  >
                  <div
                    v-if="errors.has(request.question_code + index + i)"
                    class="help-block passengewarn"
                  >
                    {{ errors.first(request.question_code + index + i) }}
                  </div>
                </div>
                <div
                  v-else-if="request.data_type === 'number' || request.data_type === '2'"
                  class="d-flex justify-content-center align-items-center row"
                >
                  <div class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>
                    {{ request.question_name }}
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    />
                  </div>
                  <input
                    :ref="request.question_code + index + i"
                    v-model="request.val"
                    v-validate="`${isrequired(request.is_required)}|numeric`"
                    type="text"
                    class="formbox col-12"
                    :placeholder="$langt('請填寫')"
                    :data-vv-as="request.question_name"
                    :name="request.question_code + index + i"
                  >
                  <div
                    v-if="errors.has(request.question_code + index + i)"
                    class="help-block passengewarn"
                  >
                    {{ errors.first(request.question_code + index + i) }}
                  </div>
                </div>
                <div
                  v-else-if="request.data_type === 'boolean' || request.data_type === '3'"
                  class="d-flex justify-content-start align-items-center row"
                >
                  <div class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>
                    {{ request.question_name }}
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    />
                  </div>
                  <div class="col-15">
                    <input
                      :ref="request.question_code + index + i"
                      v-model="request.val"
                      v-validate="`${isrequired(request.is_required)}`"
                      type="radio"
                      :value="true"
                      class="checkbox "
                      :data-vv-as="request.question_name"
                      :name="request.question_code + index + i"
                    >
                    <span> {{ $langt('是') }}</span>
                  </div>
                  <div class="col-5">
                    <input
                      :ref="request.question_code + index + i"
                      v-model="request.val"
                      v-validate="`${isrequired(request.is_required)}`"
                      type="radio"
                      class="checkbox "
                      :value="false"
                      :data-vv-as="request.question_name"
                      :name="request.question_code + index + i"
                    >
                    <span> {{ $langt('否') }}</span>
                  </div>
                  <div
                    v-if="errors.has(request.question_code + index + i)"
                    class="help-block col-12 passengewarn"
                  >
                    {{ errors.first(request.question_code + index + i) }}
                  </div>
                </div>
                <div
                  v-else-if="request.data_type === 'single' || request.data_type === '7'"
                  class="d-flex justify-content-start align-items-center row"
                >
                  <label class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>
                    {{ request.question_name }}
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    />
                  </label>
                  <b-form-select
                    :ref="request.question_code + index + i"
                    v-model="request.val"
                    v-validate="`${isrequired(request.is_required)}`"
                    class="col-12"
                    :data-vv-as="request.question_name"
                    :name="request.question_code + index + i"
                  >
                    <b-form-select-option
                      v-for="option in request.data_options"
                      :key="option.value"
                      :value="option.value"
                      :placeholder="$langt('請選擇')"
                    >
                      {{ option.label }}
                    </b-form-select-option>
                  </b-form-select>
                  <div
                    v-if="errors.has(request.question_code + index + i)"
                    class="help-block col-12 passengewarn"
                  >
                    {{ errors.first(request.question_code + index + i) }}
                  </div>
                </div>
                <div
                  v-else-if="request.data_type === 'multiple' || request.data_type === '8'"
                  class="d-flex justify-content-start align-items-center row"
                >
                  <label class="col-12 p-0">
                    <span v-if="request.is_required" style="color:red">*</span>{{ request.question_name }}
                    <b-icon
                      v-if="request.question_description"
                      v-b-tooltip.hover="request.question_description"
                      class="excicon"
                      icon="exclamation-circle-fill"
                      variant="secondary"
                    /></label>
                  <b-form-select
                    :ref="request.question_code + index + i"
                    v-model="request.val"
                    v-validate="`${isrequired(request.is_required)}`"
                    class="col-12"
                    multiple
                    :placeholder="$langt('請選擇')"
                    :data-vv-as="request.question_name"
                    :name="request.question_code + index + i"
                  >
                    <b-form-select-option
                      v-for="option in request.data_options"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.label }}
                    </b-form-select-option>
                  </b-form-select>
                  <div
                    v-if="errors.has(request.question_code + index + i)"
                    class="help-block col-12 passengewarn"
                  >
                    {{ errors.first(request.question_code + index + i) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 使用優惠券 -->
        <div class="order-area">
          <div class="sub-title">
            <span>{{ $langt('使用優惠券') }}</span>
          </div>
          <div class="form-area">
            <div class="d-flex">
              <b-col cols="8" style="padding:0">
                <input
                  ref="discount_num"
                  v-model="infoForm.discount_num"
                  type="text"
                  class="box"
                  :placeholder="$langt('請輸入優惠券並點擊檢查')"
                  @change="handlediscountnum(infoForm.discount_num)"
                >
              </b-col>
              <b-col cols="4">
                <button class="btn btn-next" @click="handleverify">
                  {{ $langt('檢查') }}
                </button>
              </b-col>
            </div>
          </div>
        </div>
        <!-- 使用好友序號 -->
        <div v-if="channel === 'richartlife'" class="order-area">
          <div class="sub-title">
            <span>{{ $langt('好友推薦序號') }}</span>
          </div>
          <div class="form-area">
            <div class="d-flex">
              <b-col cols="8" style="padding:0">
                <input
                  ref="share_code"
                  v-model="infoForm.share_code"
                  v-validate="'max:10'"
                  type="text"
                  class="box"
                  name="share_code"
                  :data-vv-as="$langt('好友推薦序號')"
                  :placeholder="$langt('請輸入好友推薦序號')"
                >
                <div v-if="errors.has('share_code')" class="help-block">
                  {{ errors.first('share_code') }}
                </div>
              </b-col>
            </div>
          </div>
        </div>

        <div class="order-area">
          <div class="sub-title">
            <span>{{ $langt('付款方式') }}</span>
          </div>
          <div class="form-area">
            <div v-for="(pay, index) of payData" :key="index">
              <div class="radiocheck mb-2">
                <input
                  :id="'pay' + index"
                  v-model="infoForm.paytype_id"
                  type="radio"
                  class="radio"
                  name="pay"
                  :value="pay.paytype_id"
                >
                <label :for="'pay' + index">{{ pay.paytype_name_web }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="order-area">
          <div class="sub-title">
            <span>{{ $langt('發票種類') }}</span>
          </div>
          <p v-if="!isnoinv_type && !shopInfo.is_tax_extra" class="text-center">
            <small class="ml-2">
              ({{ $langt('三聯式發票開立後無法更換為二聯式發票') }})
            </small>
          </p>
          <div class="form-area">
            <div v-if="isnoinv_type" class="radiocheck mb-2">
              <input
                id="radio0"
                v-model="infoForm.inv_type"
                type="radio"
                class="radio"
                name="radio0"
                value="0"
              >
              <label for="radio0">{{ $langt('免發票') }}</label>
            </div>

            <div v-if="!isnoinv_type && !shopInfo.is_tax_extra" class="radiocheck mb-2">
              <input
                id="radio2"
                v-model="infoForm.inv_type"
                type="radio"
                class="radio"
                name="radio3"
                value="1"
              >
              <label for="radio2">{{ $langt('電子發票二聯') }}</label>
            </div>

            <div v-if="!isnoinv_type && !shopInfo.is_tax_extra" class="radiocheck clicker">
              <input
                id="radio3"
                v-model="infoForm.inv_type"
                type="radio"
                class="radio"
                name="radio3"
                value="3"
              >
              <label for="radio3">{{ $langt('電子發票三聯') }}</label>
            </div>

            <div v-if="infoForm.inv_type === '3'" class="bill">
              <input
                v-model="infoForm.inv_uni_title"
                v-validate="'required'"
                type="text"
                class="box"
                :placeholder="$langt('發票抬頭')"
                name="inv_uni_title"
                :data-vv-as="$langt('發票抬頭')"
              >
              <div v-if="errors.has('inv_uni_title')">
                <div class="help-block">
                  {{ errors.first('inv_uni_title') }}
                </div>
              </div>
              <input
                v-model="infoForm.inv_uni_num"
                v-validate="'required|min:8|max:8|integer'"
                type="text"
                class="box"
                :placeholder="$langt('發票統編')"
                name="inv_uni_num"
                :data-vv-as="$langt('發票統編')"
              >
              <div v-if="errors.has('inv_uni_num')">
                <div class="help-block">
                  {{ errors.first('inv_uni_num') }}
                </div>
              </div>
            </div>

            <template v-if="!isnoinv_type && shopInfo.is_tax_extra">
              <div class="radiocheck mb-2">
                <input
                  id="radio2"
                  v-model="infoForm.inv_type"
                  type="radio"
                  class="radio"
                  name="radio3"
                  value="5"
                >
                <label for="radio2">{{ $langt('電子收據') }}</label>
              </div>
              <div class="bill">
                <input
                  v-model="infoForm.inv_uni_title"
                  v-validate="''"
                  type="text"
                  class="box"
                  :placeholder="'Company Name'"
                  name="inv_uni_title"
                  :data-vv-as="'Company Name'"
                >
                <div v-if="errors.has('inv_uni_title')">
                  <div class="help-block">
                    {{ errors.first('inv_uni_title') }}
                  </div>
                </div>
                <input
                  v-model="infoForm.inv_uni_num"
                  v-validate="''"
                  type="text"
                  class="box"
                  :placeholder="'VAT/GST Number'"
                  name="inv_uni_num"
                  :data-vv-as="'VAT/GST Number'"
                >
                <div v-if="errors.has('inv_uni_num')">
                  <div class="help-block">
                    {{ errors.first('inv_uni_num') }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="order-area">
          <div class="sub-title">
            <span>{{ $langt('訂單備註') }}</span>
          </div>
          <div class="form-area small-mobile">
            <textarea
              v-model="infoForm.remark"
              v-validate="'max:255'"
              :data-vv-as="$langt('訂單備註')"
              name="remark"
              rows="3"
              class="form-control mb-3"
            />
            <div v-if="errors.has('remark')">
              <div class="help-block">
                {{ errors.first('remark') }}
              </div>
            </div>
            <div class="radiocheck check checkcredicbarea">
              <input
                id="checkcredicb"
                v-model="checkedRule"
                type="checkbox"
                class="checkbox"
                name="checkcredicb"
              >
              <label
                for="checkcredicb"
              ><span>{{ $langt('我已閱讀') }}</span>
                <b-link v-b-modal.modal-scrollable-1>{{
                  shop.cancel_name
                }}</b-link>
                <span>{{ $langt('與') }}</span>
                <b-link v-b-modal.modal-scrollable-2>{{
                  shop.personal_name
                }}</b-link>
                <span v-if="storeRefundable">{{ $langt('，並同意取消訂單時，由商城代為處理發票及銷貨退回證明單。') }}</span>
                <span v-else>{{ $langt('。請注意：此商品不能退貨。') }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="ready" class="price-items-fix">
      <div v-if="orderItem.type() === 'point'" class="info-box">
        <span>{{ $langt('訂單金額') }}</span>
        <em><big>{{ orderItem.pointTotalPoint() }}</big>{{ $langt('點') }}＋{{ currencyCode | currencyTitle }}<big>{{ orderItem.pointTotalPrice() | priceFormat(currencyCode) }}</big></em>
      </div>
      <div v-else class="info-box">
        <span>{{ $langt('訂單金額') }}</span>
        <em v-if="isuseticket">
          <span
            style="	text-decoration:line-through;"
          >{{ currencyCode | currencyTitle }}<big>
            {{ orderItem.creditTotalPrice() | priceFormat(currencyCode) }}</big></span>
          {{ currencyCode | currencyTitle }}<big> {{ tickeyTotalprice | priceFormat(currencyCode) }}</big></em>
        <em
          v-else
        >{{ currencyCode | currencyTitle }}<big> {{ orderItem.creditTotalPrice() | priceFormat(currencyCode) }}</big></em>
      </div>
      <button class="btn btn-next" type="button" @click="doPayment()">
        {{ $langt('下一步') }}
      </button>
    </div>
    <form
      ref="paymentForm"
      :action="paymentInfo.endPoint"
      method="POST"
      style="display: none;"
    >
      <input
        v-for="(val, key) in paymentInfo"
        :key="key"
        :name="key"
        :value="val"
        type="hidden"
      >
    </form>
    <div v-if="$store.getters.shopInfo">
      <b-modal id="modal-scrollable-1" scrollable :title="shop.cancel_name">
        <div class="main py-3">
          <dl>
            <dt>{{ shop.cancel_name }}</dt>
            <dd class="nl2br" v-text="$store.getters.shopInfo.cancel_policy" />
          </dl>
        </div>
        <template #modal-footer="{ hide }">
          <b-button size="sm" variant="outline-secondary" @click="hide('')">
            close
          </b-button>
        </template>
      </b-modal>

      <b-modal id="modal-scrollable-2" scrollable :title="shop.personal_name">
        <div class="main py-3">
          <dl>
            <dt>{{ shop.personal_name }}</dt>
            <dd
              class="nl2br"
              v-text="$store.getters.shopInfo.personal_policy"
            />
          </dl>
          <dl>
            <dt>{{ shop.channel_name }}</dt>
            <dd class="nl2br" v-text="$store.getters.shopInfo.channel_policy" />
          </dl>
        </div>

        <template #modal-footer="{ hide }">
          <b-button size="sm" variant="outline-secondary" @click="hide('')">
            close
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
// import Promotionsbanner from '@/components/Promotionsbanner'
import HeaderInter from '@/components/HeaderInter'
import {
  showNotice,
  getStoreCode,
  checkPlatform,
  getDateFormat,
  storeRefundable
} from '@/utils/tool'
import { addStep1 } from '@/api/payment'
import invoiceDonate from '@/assets/data/invoice_donate.json'
import { getItem, getPaytype, checkNum, getRegionCity, getRegionArea } from '@/api/shop'
import { getMember } from '@/api/user'
import orderItem from '@/utils/orderItem'
import { VsaList, VsaItem, VsaHeading, VsaContent } from 'vue-simple-accordion'
import { handlePromotions } from '@/utils/promotions'
import CryptoJS from 'crypto-js'
import store from '../../store'
import { gtmBeginCheckout } from '@/utils/gtmtool'

export default {
  name: 'OrderUserInfo',
  components: {
    HeaderInter,
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent
  },
  data() {
    const price = this.$store.getters.orderItem.plans[0].prices[0]
    const qty = price.qty
    const point = price.point ? price.point * qty : 0
    const amount = price.sale_price ? price.sale_price * qty : 0
    // const extraTax = Math.round((this.$store.getters.extraTaxRate * amount) * (10 ** 8)) / (10 ** 8)
    const decimalPlace = this.$store.getters.currencyDecimalPlace
    const extraTaxWithDecimalPlace = Math.round((this.$store.getters.extraTaxRate * amount) *
      (10 ** decimalPlace)) / (10 ** decimalPlace)
    return {
      channel: getStoreCode(),
      ready: false,
      orderItem: orderItem,
      productDetail: false,
      invoiceDonate: invoiceDonate,
      checkedRule: false,
      userData: {},
      isnoinv_type: false, // 免發票
      infoForm: {
        partner: this.$cookies.get('partner_code'),
        campaign: this.$cookies.get('campaign_code'),
        trans_point: point,
        trans_amount: amount + extraTaxWithDecimalPlace,
        paytype_id: 1,
        mobile: null,
        id_no: null, // 欄位
        bill_name: null, // 欄位
        bill_phone: null, // 欄位
        bill_email: null, // 欄位
        bill_country_code: '',
        phone_type: 1,
        inv_type: '1', // 欄位 //發票種類,0 免發票 1 電子發票二聯 2 二聯紙本 3 電子發票三聯 4 捐贈 5電子收據
        inv_uni_num: null, // 欄位
        inv_uni_title: null, // 欄位
        remark: '',
        is_use_member: 'f',
        inv_donate: null, // 欄位 1106
        discount_num: '', // 優惠券代碼
        share_code: '', // 好友代碼
        productrequest: [], // 出行人資訊
        touristprequest: { fqa: [], people: [] },
        bookingprequest: { fqa: [], people: [] },
        ship_name: '', // 收件人姓名
        ship_phone_type: 1,
        ship_country_code: '', // 收件人電話>國碼
        ship_phone: '', // 收件人電話
        ship_city_id: '', // 收件人地址>城市id
        ship_area_id: '', // 收件人地址>鄉鎮市區id
        ship_addr: '' // 收件人地址>詳細地址
      },
      paymentInfo: {
        endPoint: null,
        MerchantID: null,
        TradeInfo: null,
        TradeSha: null,
        Version: 1.6
      },
      payData: [], // 付款方式資料
      shop: {
        cancel_name: this.$store.getters.shopInfo.cancel_name,
        personal_name: this.$store.getters.shopInfo.personal_name,
        channel_name: this.$store.getters.shopInfo.channel_name
      },
      isuseticket: false,
      tickeyTotalprice: 0,
      opappordernum: null,
      opKey: 'L@CA#z5xUZpx6BTwubp9C9Q^3Lr96&Xn',
      opIV: 'yK^5N5a&VCjXVrfE',
      bind_paytype: [],
      cityList: [],
      areaList: []
    }
  },
  computed: {
    type: function() {
      return this.item.plans[0].prices[0].point_id ? 'point' : 'credit'
    },
    item: function() {
      return this.$store.getters.orderItem
    },
    qty: function() {
      return this.item.plans[0].prices[0].qty
    },
    // date() {
    //   const dateStr = orderItem.plans[0].prices[0].date || ''
    //   const timeStr = orderItem.plans[0].prices[0].selectedTime || ''
    //    // 如果有時間，合併成 "YYYY-MM-DD HH:mm:ss" 格式，沒有時間就只回傳日期
    //   return timeStr ? `${dateStr} ${timeStr}` : dateStr
    // },
    storeRefundable: function() {
      return storeRefundable()
    },
    currencyCode: function() {
      return this.$store.getters.currencyCode
    },
    isUseMember: {
      get() {
        if (this.infoForm.is_use_member === 't') return true
        return false
      },
      set(newValue) {
        if (newValue) {
          this.infoForm.is_use_member = 't'
        } else {
          this.infoForm.is_use_member = 'f'
        }
      }
    },
    phoneOptions() {
      return [
        {
          label: this.$store.getters.shopInfo.country_name || '',
          value: 1
        },
        {
          label: 'other',
          value: 2
        }
      ]
    },
    countryCodeDefault() {
      return this.$store.getters.shopInfo.country_code
    },
    shopInfo() {
      return this.$store.getters.shopInfo
    }
  },
  created() {
    // 註冊opapp錢包
    window.OPGetWalletStatusV2Result = this.OPGetWalletStatusV2Result.bind(this)
    window.OPOnlinePaymentResult = this.OPOnlinePaymentResult.bind(this)
    if (!this.item || !this.item.item_id) {
      const self = this
      showNotice(this.$langt('請選擇方案、數量'), function() {
        self.$router.push({ path: '/product' }).catch(() => {})
      })
    } else {
      getItem(this.item.item_id, { get_bind_paytype: 't' }).then(response => {
        this.productDetail = response.data.data
        // 商品限定金流
        if (response.data.data.bind_paytype.length) {
          this.bind_paytype = response.data.data.bind_paytype
        }
        this.orderItem.init(
          this.$store.getters.orderItem,
          this.productDetail,
          '/product',
          this.$store.getters.currencyCode,
          this.$store.getters.currencyDecimalPlace,
          this.$store.getters.extraTaxRate
        )
        if (this.orderItem.plan()) {
          if (
            this.orderItem.plan().product_request &&
            this.orderItem.plan().product_request.length
          ) {
            this.orderItem.plan().product_request.forEach(ee => {
              if (ee.data_type === 'multiple' || ee.data_type === '8') {
                ee.val = []
              } else if (ee.data_type === 'datetime' || ee.data_type === '6') {
                ee.val0 = ''
                ee.val1 = ''
              } else ee.val = null

              if (ee.question_type === 'booking' || ee.question_type === '2') {
                this.infoForm.touristprequest.fqa.push(ee)
              } else if (ee.question_type === 'tourist' || ee.question_type === '1') {
                this.infoForm.bookingprequest.fqa.push(ee)
              }
            })
            if (this.infoForm.touristprequest.fqa.length) {
              const iseveryone = this.infoForm.touristprequest.fqa.find(e => {
                return e.is_everyone === true
              })
              if (iseveryone) {
                for (let index = 0; index < this.orderItem.qty(); index++) {
                  if (index === 0) {
                    this.infoForm.touristprequest.people.push({
                      data: JSON.parse(
                        JSON.stringify(this.infoForm.touristprequest.fqa)
                      )
                    })
                  } else {
                    const reqdata = []
                    this.infoForm.touristprequest.fqa.forEach(e1 => {
                      if (e1.is_everyone) {
                        reqdata.push(JSON.parse(JSON.stringify(e1)))
                      }
                    })
                    this.infoForm.touristprequest.people.push({ data: reqdata })
                  }
                }
              } else {
                this.infoForm.touristprequest.people.push({
                  data: JSON.parse(
                    JSON.stringify(this.infoForm.touristprequest.fqa)
                  )
                })
              }
            }
            if (this.infoForm.bookingprequest.fqa.length) {
              const iseveryone = this.infoForm.bookingprequest.fqa.find(e => {
                return e.is_everyone === true
              })
              if (iseveryone) {
                for (let index = 0; index < this.orderItem.qty(); index++) {
                  if (index === 0) {
                    this.infoForm.bookingprequest.people.push({
                      data: JSON.parse(
                        JSON.stringify(this.infoForm.bookingprequest.fqa)
                      )
                    })
                  } else {
                    const reqdata = []
                    this.infoForm.bookingprequest.fqa.forEach(e1 => {
                      if (e1.is_everyone) {
                        reqdata.push(JSON.parse(JSON.stringify(e1)))
                      }
                    })
                    this.infoForm.bookingprequest.people.push({ data: reqdata })
                  }
                }
              } else {
                this.infoForm.bookingprequest.people.push({
                  data: JSON.parse(
                    JSON.stringify(this.infoForm.bookingprequest.fqa)
                  )
                })
              }
            }
          }

          // GTM電子商務 begin_checkout //
          try {
            const currency = this.productDetail.currency_code
            const value = this.$store.getters.orderItem.plans[0].prices[0].sale_price * this.$store.getters.orderItem.plans[0].prices[0].qty
            const price_id = this.$store.getters.orderItem.plans[0].prices[0].price_id
            const { plan, price } = this.searchByPriceId(price_id)
            const items = [{
              item_id: price_id,
              item_name: this.getName(plan, price)
            }]
            gtmBeginCheckout(items, currency, value)
          } catch (error) {
            console.log(error)
          }
        }

        // 取得付款方式資料 若是付費金額為0元的點數商品 若不是則呼叫call api getPaytype
        // 點數支付且價格為0
        if (
          (this.orderItem.type() === 'credit' &&
            this.orderItem.creditTotalPrice() === 0) ||
          (this.orderItem.type() === 'point' &&
            this.orderItem.pointTotalPrice() === 0)
        ) {
          this.isnoinv_type = true
          this.infoForm.inv_type = 0
          // if only point and price = 0 set the payment type = -1
          const freepay = [
            {
              paytype_id: -1,
              paytype_name_web: this.$langt('免付費'),
              payment: ''
            }
          ]
          this.infoForm.paytype_id = -1
          this.payData = freepay
          this.getMemberInfo()
          this.ready = true
        } else {
          getPaytype().then(response => {
            if (response.data.data.length) {
              // 信託付款的產品找出信託付款的選項 若是付款方式不符合信託trustor errormsg => 回產品清單頁面
              if (this.orderItem.productDetail.trustor_code) {
                this.payData = response.data.data.filter(e => {
                  if (
                    e.trustor_code === this.orderItem.productDetail.trustor_code
                  ) {
                    return e
                  }
                })
                if (!this.payData.length) {
                  showNotice(this.$langt('產品資訊錯誤, 請選擇其他商品!'), () => {
                    this.$router.push({ path: '/product/cate/0' })
                  })
                }
              } else {
                // 正常的付款選項先濾掉信託的支付
                this.payData = response.data.data.filter(e => {
                  if (e.trustor_code === null) {
                    return e
                  }
                })
                // 若OPAPP 濾掉icash
                if (
                  this.$store.getters.isinapp &&
                  this.$store.getters.isinapp.name === 'opapp'
                ) {
                  this.payData = this.payData.filter(e => {
                    if (e.payment !== 'icash') {
                      return e
                    }
                  })
                } else if (
                  this.$store.getters.isinapp &&
                  this.$store.getters.isinapp.name === 'icash'
                ) {
                  // 若 icash  濾掉 cathaybk 國泰聚合
                  this.payData = this.payData.filter(e => {
                    if (e.payment !== 'cathaybk') {
                      return e
                    }
                  })
                }
                // 假如指定支付

                const tmppayarray = []
                if (this.bind_paytype.length) {
                  this.payData.forEach(e => {
                    const isfind = this.bind_paytype.find(e1 => {
                      return (
                        e1.paytype_id.toString() === e.paytype_id.toString()
                      )
                    })
                    if (isfind) tmppayarray.push(e)
                  })
                  this.payData = tmppayarray
                  if (this.payData.length) {
                    this.infoForm.paytype_id = this.payData[0].paytype_id
                  } else {
                    showNotice(this.$langt('該商品指定支付金流目前尚未開啟, 請先選擇其他商品!'), () => {
                      this.$router.push({ path: '/product/cate/0' })
                    })
                  }
                }
              }

              if (this.payData[0].payment === 'icash') {
                this.infoForm.paytype_id = 5
              }
              if (this.payData.length) {
                this.infoForm.paytype_id = this.payData[0].paytype_id
              }
              // 取會員資料
              this.getMemberInfo()
              this.ready = true
            } else {
              showNotice(this.$langt('付款金流資訊錯誤, 請選擇其他商品!'), () => {
                this.$router.push({ path: '/product/cate/0' })
              })
            }
          })
        }

        // 宅配 style = 2 or 3 > 讀取城市 & 市區列表
        if (this.productDetail.style === 2 || this.productDetail.style === 3) {
          this.infoForm.ship_country_code = this.$store.getters.shopInfo.country_code || ''
          this.getCityList()
        }
      })
    }

    if (this.$store.getters.shopInfo.is_tax_extra) {
      this.infoForm.inv_type = '5' // 電子收據 inv_type = 5
    }
  },
  methods: {
    isrequired(status) {
      if (status) {
        return 'required'
      } else return ''
    },
    OPOnlinePaymentResult(data, payment_status) {
      if (payment_status) {
        this.$router.push({ path: '/order/checkPaid?id=' + this.opappordernum })
      }
    },
    OPGetWalletStatusV2Result(
      wallet_status,
      is_opw,
      is_icashpay,
      opwcard_issuer_list
    ) {
      // 當確認成功
      if (wallet_status === 'Y' || is_opw === 'Y' || is_icashpay === 'Y') {
        const data = {
          datetime: getDateFormat(new Date()) + '', // 時間
          merchant_trade_no: this.opappordernum + '', // 訂單編號
          terminal_id: '83501114', // 統編
          merchant_data: '', // 商家端資料
          icp_merchant_id: process.env.VUE_APP_ICP_MERCHANT_ID // 無帶空直
        }
        const encrypted = CryptoJS.AES.encrypt(
          JSON.stringify(data),
          CryptoJS.enc.Utf8.parse(this.opKey),
          {
            iv: CryptoJS.enc.Utf8.parse(this.opIV),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        )
        const args = {
          source: '3TW',
          data: encrypted.toString()
        }
        if (encrypted.toString()) {
          window.OPAPPJsInterface.call('OPOnlinePayment', args)
        }
      } else {
        showNotice(
          this.$langt('無綁定任何支付，請先回到APP綁定您的支付功能!'),
          function() {}
        )
      }
    },
    handlediscountnum(val) {
      if (this.isuseticket) {
        this.isuseticket = false
      }
    },
    async handleverify() {
      try {
        const requestdata = {
          num: this.infoForm.discount_num,
          items: []
        }
        requestdata.items.push(this.item)
        const res = await checkNum(requestdata)
        if (res.data.succ && res.data.data) {
          this.isuseticket = true
          this.tickeyTotalprice =
            parseInt(this.orderItem.creditTotalPrice()) -
            parseInt(res.data.data)
          showNotice(this.$langt('優惠券可使用'), () => {})
        } else {
          this.isuseticket = false
          showNotice(
            this.$langt('此優惠券序號無效，請確認輸入的序號是否正確。 \r\n\r\n 優惠券序號無效的可能原因： \r\n - 輸入錯誤的優惠券序號 \r\n - 優惠券序號已使用 \r\n - 優惠券序號已逾期 \r\n - 訂單商品或金額未符合使用規定 \r\n - 非原先取得優惠券序號之帳號登入使用'),
            () => {}
          )
        }
      } catch (error) {
        this.isuseticket = false
        console.log(error)
      }
    },
    toggleSync(checked) {
      if (!checked) {
        this.infoForm.bill_phone = ''
        this.infoForm.bill_email = ''
        this.infoForm.bill_name = ''
      } else {
        this.infoForm.bill_email = this.$store.getters.memberInfo.email || ''
        this.infoForm.bill_name = this.$store.getters.memberInfo.name || ''

        const { country_code, phone } = this.$store.getters.memberInfo
        if (country_code) {
          this.infoForm.bill_phone = `${country_code} ${phone}`
        } else {
          this.infoForm.bill_phone = phone || ''
        }
      }
    },
    getMemberInfo(callback) {
      // 取會員資料
      getMember()
        .then(response => {
          if (response.data.data.member_id !== undefined) {
            this.$store.commit('SET_MEMBER_INFO', response.data.data)
            // 若會員以輸入資料 自動帶入資料
            if (response.data.data.email) {
              this.isUseMember = true
              this.toggleSync(true)
            }
          }
          if (callback !== undefined) {
            callback()
          }
        })
        .catch(() => {})
    },
    getPay(paytype_id) {
      return this.payData.filter(pay => pay.paytype_id === paytype_id).pop()
    },
    async doPayment() {
      this.$validator.validateAll().then(async valid => {
        if (valid) {
          if (!this.checkedRule) {
            showNotice(this.$langt('請勾選同意以下說明：「我己閱讀') +
              this.shop.cancel_name +
              this.$langt('與') +
              this.shop.personal_name +
              this.$langt('，並同意取消訂單時，由商城代為處理發票及銷貨退回證明單。」')
            )
          } else {
            this.infoForm.platform = checkPlatform()
            this.infoForm.mobile = this.infoForm.bill_phone
            this.$store.commit('SET_ORDER_INFO', this.infoForm)
            const order = this.infoForm
            order.items = []
            order.items.push(this.item)
            this.$store.commit('SET_LOADING', true)
            const self = this
            // 出行人問題組合-訂單+旅客  bookingprequest touristprequest-->
            if (
              this.infoForm.touristprequest.people.length ||
              this.infoForm.bookingprequest.people.length
            ) {
              const tmpArray = []
              for (let i = 0; i < this.orderItem.qty(); i++) {
                const ele = { isexist: false }
                const bookingTime = `${this.orderItem.item.plans[0].prices[0].date}`
                const bookingTime2 = `${this.orderItem.item.plans[0].prices[0].date} ${this.orderItem.item.plans[0].prices[0].selectedTime}`
                if (this.infoForm.touristprequest.people.length > i) {
                  ele.isexist = true
                  this.infoForm.touristprequest.people[i].data.forEach(e1 => {
                    if (e1.data_type === '4') {
                      ele[e1.question_code] = [bookingTime]
                    } else if (e1.data_type === '6') {
                      ele[e1.question_code] = [bookingTime2]
                    }else if (!Array.isArray(e1.val)) {
                      ele[e1.question_code] = e1.val ? [e1.val] : []
                    } else {
                      ele[e1.question_code] = e1.val
                    }
                  })
                }

                if (this.infoForm.bookingprequest.people.length > i) {
                  ele.isexist = true
                  this.infoForm.bookingprequest.people[i].data.forEach(e1 => {
                    if (e1.data_type === '4') {
                      ele[e1.question_code] = [bookingTime]
                    } else if (e1.data_type === '6') {
                      ele[e1.question_code] = [bookingTime2]
                    } else if (!Array.isArray(e1.val)) {
                      ele[e1.question_code] = e1.val ? [e1.val] : []
                    } else {
                      ele[e1.question_code] = e1.val
                    }
                  })
                }

                if (ele.isexist) {  //只推有資料的
                  delete ele.isexist
                  tmpArray.push(ele)
                }
              }
              
              this.infoForm.items[0].plans[0].prices[0].product_request = tmpArray

            }


            // 出行人問題組合 <---
            if (this.infoForm.discount_num !== '') {
              const requestdata = {
                num: this.infoForm.discount_num,
                items: []
              }
              requestdata.items.push(this.item)
              const checkNumres = await checkNum(requestdata)
              if (checkNumres.data.succ && checkNumres.data.data) {
                this.isuseticket = true
                order.finalamount =
                  parseInt(order.trans_amount) - parseInt(checkNumres.data.data)
              } else {
                this.$store.commit('SET_LOADING', false)
                showNotice(
                  this.$langt('此優惠券序號無效，請確認輸入的序號是否正確。 \r\n\r\n 優惠券序號無效的可能原因： \r\n - 輸入錯誤的優惠券序號 \r\n - 優惠券序號已使用 \r\n - 優惠券序號已逾期 \r\n - 訂單商品或金額未符合使用規定 \r\n - 非原先取得優惠券序號之帳號登入使用'),
                  () => {}
                )
                return false
              }
            } else {
              this.isuseticket = false
            }
            if (
              handlePromotions(
                this.infoForm.bill_email,
                this.infoForm.is_use_member,
                order.trans_amount
              )
            ) {
              // GTM電子商務 紀錄購買項目，提供訂單完成後分析 //
              try {
                const currency = this.productDetail.currency_code
                const value = this.$store.getters.orderItem.plans[0].prices[0].sale_price * this.$store.getters.orderItem.plans[0].prices[0].qty
                const price_id = this.$store.getters.orderItem.plans[0].prices[0].price_id
                const { plan, price } = this.searchByPriceId(price_id)
                const items = [{
                  item_id: price_id,
                  item_name: this.getName(plan, price)
                }]
                this.$store.commit('SET_PAYING_DATA', { items, currency, value })
              } catch (error) {
                console.log(error)
              }
              // 最後送出的結果
              const reqdata = JSON.parse(JSON.stringify(order))
              // 若有使用折扣
              if (this.isuseticket) {
                reqdata.trans_amount = JSON.parse(
                  JSON.stringify(order.finalamount)
                )
              }
              const paycheck3t = /^3tpay/g

              // 非預設聯絡人, 手動輸入>使用預設shop國碼
              if (this.infoForm.is_use_member === 'f' && this.infoForm.phone_type === 1) {
                reqdata.bill_country_code = this.$store.getters.shopInfo.country_code
              }

              addStep1(reqdata)
                .then(response => {
                  if (response.data.code !== 0) {
                    if (response.data.code === 'HG5015') {
                      showNotice(this.$langt('請檢查您的手機號和身分證是否輸入正確'))
                    } else if (response.data.code === -1) {
                      const memberInfo = self.$store.getters.memberInfo
                      // 回填上一筆訂單的資料
                      self.isUseMember = false
                      self.toggleSync(false)
                      self.infoForm.bill_phone = memberInfo.latest_phone || ''
                      self.infoForm.bill_email = memberInfo.latest_email || ''
                      self.infoForm.bill_name = memberInfo.latest_name || ''
                    }
                  } else {
                    if (self.type === 'point' && this.channel === 'happygo') {
                      // 點加金要紀錄 若金流失敗要回扣
                      if (
                        response.data.data.orders_point_id === undefined ||
                        response.data.data.orders_point_id + '' === ''
                      ) {
                        showNotice(this.$langt('HappyGo點數扣除異常'))
                        return
                      } else {
                        self.$store.commit(
                          'SET_PAYMENT_ORDER_ID',
                          response.data.data.orders_point_id
                        )
                      }
                    }
                    const pay = this.getPay(order.paytype_id)
                    if (pay.payment === 'newebCreditcard') {
                      self.paymentInfo = response.data.data.payment
                      self.paymentInfo.endPoint = response.data.data.endPoint
                      this.$nextTick(() => {
                        this.$refs.paymentForm.submit()
                      })
                    } else if (pay.payment === 'tscbOne') {
                      // 若是HG使用台新支付
                      if (this.channel === 'happygo' || this.channel === '3t') {
                        window.happyGoAppjscontext.call(
                          'openExternalBrowser',
                          response.data.data.endPoint,
                          () => {
                            self.$router.push({
                              path:
                                '/order/qrcode/' +
                                'none' +
                                '/' +
                                'tscb' +
                                '/' +
                                response.data.data.id
                            })
                          }
                        )
                      } else {
                        window.location.href = response.data.data.endPoint
                      }
                    } else if (pay.payment === 'sinopacCreditcard') {
                      window.location.href = response.data.data.endPoint
                    } else if (pay.payment === 'easyCard') {
                      if (response.data.data.endPoint) {
                        window.open(response.data.data.endPoint, '_self')
                      } else {
                        showNotice(this.$langt('系統錯誤請確認!'))
                      }
                    } else if (pay.payment === 'icash') {
                      // 轉址 或 產生QRCODE
                      if (response.data.data.endPoint) {
                        try {
                          const urlParams = new URLSearchParams(
                            response.data.data.endPoint
                          )
                          let tradeToken = urlParams.get('Value')

                          if (checkPlatform() === 'android') {
                            tradeToken = encodeURIComponent(tradeToken)
                          }
                          window.iCashJSContext.call(
                            'OpenWebActivity',
                            tradeToken,
                            '3tgds'
                          )
                        } catch (error) {
                          console.log(error)
                        }
                      } else if (response.data.data.payment.qrCode) {
                        this.$router.push({
                          path:
                            '/order/qrcode/' +
                            response.data.data.payment.qrCode +
                            '/' +
                            pay.payment +
                            '/' +
                            response.data.data.id
                        })
                      }
                    } else if (pay.payment === 'cathaybk') {
                      if (pay.pay_code === 'OPW' && checkPlatform() === 'web') {
                        window.location.href = response.data.data.endPoint
                      } else if (
                        store.getters.isinapp.name === 'opapp' &&
                        response.data.data.payment.credit_num
                      ) {
                        try {
                          // call 一段檢查取得使用者當下是否有支付工具，
                          // 透過OPGetWalletStatusV2Result回傳結果(有無OPW信用卡與ICP是否有登入)與使用者有哪些OPW信用卡
                          window.OPAPPJsInterface.call(
                            'OPGetWalletStatusV2',
                            null
                          )

                          this.opappordernum =
                            response.data.data.payment.credit_num
                        } catch (error) {
                          console.log('error===>' + error)
                        }
                      }
                    } else if (paycheck3t.test(pay.payment)) {
                      if (response.data.data.payment) {
                        self.paymentInfo = response.data.data.payment
                        self.paymentInfo.endPoint = response.data.data.endPoint
                        this.$nextTick(() => {
                          this.$refs.paymentForm.submit()
                        })
                      } else if (response.data.data.endPoint) {
                        window.open(response.data.data.endPoint, '_self')
                      } else {
                        showNotice(this.$langt('系統錯誤請確認!'))
                      }
                    } else {
                      // 下單成功
                      this.$router
                        .push({
                          path: '/order/finish',
                          query: { order_num: response.data.data.order_num }
                        })
                        .catch(() => {})
                    }
                  }
                })
                .catch(() => {})
                .finally(() => {
                  self.$store.commit('SET_LOADING', false)
                })
            } else {
              showNotice(this.$langt('系統提醒:資料錯誤。'), function() {})
            }
          }
        } else {
          if (this.errors.items.length) {
            if (Array.isArray(this.$refs[this.errors.items[0].field])) {
              this.$refs[this.errors.items[0].field][0].focus()
            } else this.$refs[this.errors.items[0].field].focus()
          }
        }
      })
    },
    async getCityList(country_id = 1) {
      try {
        const payload = {
          country_id
        }
        const { data } = await getRegionCity(payload) // 取得城市
        if (data.succ) {
          this.cityList = data.data
          const { city_id } = data.data[0]
          this.infoForm.ship_city_id = city_id
          this.getAreaList(city_id) // 取得區
        }
      } catch (error) {
        // error
      }
    },
    async getAreaList(city_id = 1) {
      try {
        const payload = {
          city_id
        }
        const { data } = await getRegionArea(payload)
        if (data.succ) {
          this.areaList = data.data
          this.infoForm.ship_area_id = data.data[0].area_id
        }
      } catch (error) {
        // error
      }
    },
    setShipCountryCode(code) {
      if (code === 1) {
        this.infoForm.ship_country_code = this.$store.getters.shopInfo.country_code || ''
      } else {
        this.infoForm.ship_country_code = ''
      }
    },
    /**
     * 用 price_id 搜尋 plan, price
     * @return { plan, price } 。沒有找到回傳 { }
     */
    searchByPriceId(price_id) {
      for (let i = 0; i < this.productDetail.plans.length; i++) {
        const plan = this.productDetail.plans[i]
        for (let j = 0; j < plan.prices.length; j++) {
          const price = plan.prices[j]
          if (parseInt(price_id) === parseInt(price.price_id)) {
            return { plan, price }
          }
        }
      }
      return {}
    },
    // 從 plan, price 計算出商品完整名稱 //
    getName(plan, price) {
      if (plan && price) {
        let result = this.productDetail.name + ' - ' + plan.plan_name + ' - ' + price.price_type
        if (price.price_name && price.price_type !== price.price_name) {
          // 避免 price_type 和 price_name 重複 //
          result += ' ' + price.price_name
        }
        return result
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
@import 'assets/scss/common.scss';

.box-group {
  margin: 0 auto 1.5rem;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0px 8px 30px 0px rgba($main-color, $alpha: 0.15);

  .box-items {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.25rem;

    // border-bottom: 2px solid rgba($white-color, $alpha: 1);
    .box-th {
      // border-left: 2px solid rgba($main-color, $alpha: 1);
      padding: 5px 15px 5px 0px;
      white-space: nowrap;
    }

    .box-td {
      text-align: right;
      padding-left: 10px;
    }
  }
}

@media screen and (max-width: 320px) {
  .small-mobile .radiocheck.check label {
    display: inherit;
  }
}

.passengewarn {
  text-align: center;
}

.orderinit-area .order-area {
  .sub-title {
    text-align: center;
    font-size: 1.15rem;
    font-weight: bolder;
    color: rgba($main-color, $alpha: 1);
    background: -webkit-gradient(
      linear,
      0 0,
      0 100%,
      color-stop(0.5, rgba($font-color, $alpha: 0.5)),
      color-stop(0.5, transparent),
      to(transparent)
    );
    background-repeat: repeat-x;
    background-position: center center;
    -webkit-background-size: 2px;
    display: block;
    margin: 0 auto 0.5rem;

    span {
      padding: 0 35px;
      background-color: $white-color;
    }
  }

  .passengerlist {
    text-align: start;
    padding-top: 1rem;
    font-size: 1.15rem;
    font-weight: bolder;
    color: rgba($font-color, $alpha: 1);
    text-align: center;
  }

  .topline {
    border-top: 1px rgb(214, 214, 214) solid;
  }

  a {
    color: rgba($main-color, $alpha: 1);
  }

  a:hover {
    color: rgba($main-color, $alpha: 1);
    text-decoration: underline;
  }

  p {
    margin: 0;
    padding: 0;
  }
}

.main {
  p {
    margin: 0 0 0.5rem;
    padding: 0;
  }

  dt {
    color: $main-color;
    margin-bottom: 0.35rem;
  }

  dd {
    line-height: 1.5rem;
    margin: 0;
    padding: 0;
  }

  dd span {
    color: $sec-color;
  }

  ol,
  ul {
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;

    .price {
      color: $notice-color;
    }
  }
}

.checkcredicbarea {
  label {
    display: inline-block;
  }
}

.order-info__phone {
  display: flex;
  align-items: center;
  gap: 12px;

  .phone-select {
    width: 100px;
  }

  .country-code {
    $width: 100px;
    width: $width;

    &:focus {
      width: $width;
    }
    &:disabled {
      cursor: not-allowed;
    }

    +.help-block {
      margin-top: 10px;
      margin-bottom: 0;
    }
  }

  .phone-number {
    flex-grow: 1;
  }
}

.order-info__address{
  display: flex;
  align-items: center;
  gap: 12px;

  .ship-select {
    width: 100px;
  }

  .ship-addr {
    flex-grow: 1;
  }
}
</style>
